export class BaseModel {
}
